module.exports = __webpack_public_path__ + "img/arrow-right.1017ec87.svg";